import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getProductList = createAsyncThunk(
  'electronic-tool/get-productList',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/dropdown-filter`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProductsKeyInformation = createAsyncThunk(
  'electronic-tool/get-productsKey-information',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/bom-analysis/bom-hierarchy/get-key-info`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAlternativePartsData = createAsyncThunk(
  'electronic-tool/get-alternate-part-information',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/bom-analysis/bom-hierarchy/get-cross-data`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProductTreeData = createAsyncThunk(
  'electronic-tool/get-product-tree-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/bom-analysis/bom-hierarchy/get-hierarchy`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPricedata = createAsyncThunk(
  'electronic-tool/get-product-tree-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/bom-analysis/bom-hierarchy/get-price-data`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//avl data
export const getAVL = createAsyncThunk(
  'electronic-tool/get-avl',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/getAvlData`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//scenario builder

export const getScenarioBuilderData2 = createAsyncThunk(
  'electronic-tool/scenario-builder/scenario-one',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v2/electronic-tool/scenario-builder/scenario-one`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioBuilderData = createAsyncThunk(
  'electronic-tool/scenario-builder/scenario-two',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v2/electronic-tool/scenario-builder/scenario-two`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioBuilderData3 = createAsyncThunk(
  'electronic-tool/scenario-builder/scenario-three',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/electronic-tool/scenario-builder/scenario-three`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getComponentDetails = createAsyncThunk(
  'electronic-tool/component-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/get-part-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCrossDataDetails = createAsyncThunk(
  'electronic-tool/get-cross-data-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/get-cross-data-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getFeatureDetails = createAsyncThunk(
  'electronic-tool/get-feature-details-and-franch',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/get-feature-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const downloadCrossDataAsync = createAsyncThunk(
  'electronic-tool/electronic-costing/download-cross-data-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/electronic-tool/download-cross-data-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Download standard templates for BOM and Component upload
export const getStandardTemplateForBOM = createAsyncThunk(
  'electronic-tool/get-standard-template-for-BOM',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/electronic-tool/download-part-details-template`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Upload Component
export const uploadFile = createAsyncThunk(
  'electronic-tool/upload-component-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/upload-components-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Upload BOM
export const uploadBOMFile = createAsyncThunk(
  'electronic-tool/upload-BOM-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/upload-bom-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get cross type details for analysis configuration
export const getCrossTypeDetails = createAsyncThunk(
  'electronic-tool/get-cross-type-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/get-cross-type-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Save cross type details for analysis configuration
export const saveCrossTypeDetails = createAsyncThunk(
  'electronic-tool/save-cross-type-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/cross-type-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Export Coverage Summary
export const exportCoverageSummary = createAsyncThunk(
  'electronic-tool/export-coverage-summary',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/download-coverage-summary_details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Parts updated progress bar
export const getPartsUploadedProgress = createAsyncThunk(
  'electronic-tool/get-progress-bar-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/electronic-tool/progress-bar-details`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)